import { createI18n } from "vue-i18n";
import { MultiLang } from "@/types/entity";
import { sessionStorageGet } from "@/tools/sessionStorage";
// 引入同级目录下文件

const modules = import.meta.glob("./*", { eager: true });
const FALLBACK_LOCALE = import.meta.env.VITE_IS_CN ? "zh-CN" : "en-US";
const FALLBACK_LOCALE_ID = import.meta.env.VITE_IS_CN ? 2 : 1;
const LOCALE_MAP: Record<string, string> = {
  1: "en-US",
  2: "zh-CN",
  3: "ja-JP",
};

enum galGameLanguages {
  "zh-CN",
  "en-US",
  "ja-JP",
  "fr-FR",
  "de-DE",
  "zh-TW",
}

export function getLocaleById(id: number) {
  return LOCALE_MAP[id];
}

export function getLocaleIdByLocale(locale: string) {
  const localeId = Object.keys(LOCALE_MAP).find(
    (key) => LOCALE_MAP[key] === locale
  );
  return localeId ? Number(localeId) : FALLBACK_LOCALE_ID;
}

//假设你还有其他目录下的语言文件 它的路径是 src/views/home/locales/en-US.ts
// const viewModules = import.meta.globEager('../views/**/locales/[[:lower:]][[:lower:]]-[[:upper:]][[:upper:]].ts')
function getLangAll() {
  const message = {};
  getLangFiles(modules, message);
  //   getLangFiles(viewModules,message)
  return message;
}

/**
 * 获取所有语言文件
 * @param {Object} mList
 */
function getLangFiles(mList, msg) {
  for (const path in mList) {
    if (mList[path].default) {
      //  获取文件名
      const pathName = path.substr(path.lastIndexOf("/") + 1, 5);

      if (msg[pathName]) {
        msg[pathName] = {
          ...mList[pathName],
          ...mList[path].default,
        };
      } else {
        msg[pathName] = mList[path].default;
      }
    }
  }
}

// 注册i8n实例并引入语言文件

export function getDefaultLocale() {
  try {
    const user = sessionStorageGet("user");
    let lang = FALLBACK_LOCALE;
    if (user) {
      const { settingDisplayLanguageId } = user;
      if (settingDisplayLanguageId === 1) lang = "en-US";
      if (settingDisplayLanguageId === 2) lang = "zh-CN";
    }

    const langStr = navigator.language.toUpperCase();
    const isChineseSystem = langStr.indexOf("ZH") > -1;

    if (isChineseSystem) {
      lang = "zh-CN";
    }
    if (document) {
      document.querySelector("html")?.setAttribute("lang", lang);
    }
    return lang;
  } catch (e) {
    return "en-US";
  }
}

export function setGalGameLanguage(locale) {
  localStorage.setItem("lang", galGameLanguages[locale] ?? 0);
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  global: true,
  locale: FALLBACK_LOCALE, // 默认语言
  fallbackLocale: FALLBACK_LOCALE, // 默认语言
  messages: getLangAll(),
  warnHtmlMessage: false,
});

export function getLocaleText(multiLang: MultiLang[]) {
  const locale = i18n.global.locale;
  const localeId = getLocaleIdByLocale(locale.value);
  const localeText = multiLang.find((item) => item.languageId === localeId);
  return localeText ? localeText.text : "";
}

export default i18n;
